module.exports = __webpack_public_path__ + "img/index.ae2cddb5.png";